import { ControlBase } from '@components/dynamic-form/control-base';
import { ControlType } from '@components/dynamic-form/control-type';
import { FormSetting } from '@/form-settings/form-setting';
import { DynamicFormComponent } from '@components/dynamic-form/dynamic-form.component';
import { AutocompleteControl } from '@components/dynamic-form/auto-complete/autocomplete-control';

export class TestDriveFormMeta extends FormSetting {
  private static rows: ControlBase[] = [];
  private static isNewForm: boolean = false;
  private static formInstance: DynamicFormComponent;

  public static setFormInstance(formInstance: DynamicFormComponent) {
    this.formInstance = formInstance;

    return this;
  }

  public static setIsNewForm(isNewForm: boolean) {
    this.isNewForm = isNewForm;

    return this;
  }

  public static getMeta(): Array<any> {
    this.rows = [];

    this.addRowId();
    this.addRowRicercaCliente();
    this.addRowBpCliente();
    this.addRowDenominazioneCliente();
    this.addRowDataNascita();
    this.addRowLuogoNascita();
    this.addRowNumeroPatente();
    this.addRowPatenteRilasciataDa();
    this.addRowPatenteRilasciataIl();
    this.addRowDataInizioTestDrive();
    this.addRowDurataMinuti();
    this.addRowVeicolo();
    this.addRowMarca();
    this.addRowModello();
    this.addRowTarga();
    this.addRowTelaio();
    this.addRowLuogoContratto();
    this.addRowDataContratto();
    this.addRowPraticaId();

    return [
      {
        rows: this.rows,
        order: 1,
      },
    ];
  }

  private static addRowId() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'id';
    inputsComponent.disabled = true;
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'ID';
    inputsComponent.class = 'w-4/12';

    this.rows.push(inputsComponent);
  }

  private static addRowRicercaCliente() {
    const inputsComponent = {} as AutocompleteControl;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'ricercaCliente';
    inputsComponent.controlType = 'autocomplete-cliente' as any;
    inputsComponent.label = 'Ricerca Cliente';
    inputsComponent.class = 'w-8/12';
    inputsComponent.required = false;
    inputsComponent.options = [];
    inputsComponent.customAction = 'onClienteSelected';

    this.rows.push(inputsComponent);
  }

  private static addRowDenominazioneCliente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'denominazioneCliente';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Nome e Cognome / Denominazione Cliente';
    inputsComponent.class = 'w-8/12';
    inputsComponent.required = true;
    inputsComponent.disabled = false; // Può essere modificato o popolato dal veicolo

    this.rows.push(inputsComponent);
  }

  private static addRowDataNascita() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'dataNascita';
    inputsComponent.controlType = ControlType.date;
    inputsComponent.label = 'Data di Nascita';
    inputsComponent.class = 'w-4/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowLuogoNascita() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'luogoNascita';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Luogo di Nascita';
    inputsComponent.class = 'w-4/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowNumeroPatente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'numeroPatente';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Numero Patente';
    inputsComponent.class = 'w-4/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowPatenteRilasciataDa() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'patenteRilasciataDa';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Patente Rilasciata Da';
    inputsComponent.class = 'w-8/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowPatenteRilasciataIl() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'patenteRilasciataIl';
    inputsComponent.controlType = ControlType.date;
    inputsComponent.label = 'Patente Rilasciata Il';
    inputsComponent.class = 'w-4/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowDataInizioTestDrive() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'dataInizioTestDrive';
    inputsComponent.controlType = ControlType.dateTime;
    inputsComponent.label = 'Data e Ora Inizio Test Drive';
    inputsComponent.class = 'w-8/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowDurataMinuti() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'durataMinuti';
    inputsComponent.controlType = ControlType.number;
    inputsComponent.label = 'Durata (minuti)';
    inputsComponent.class = 'w-4/12';
    inputsComponent.required = true;

    this.rows.push(inputsComponent);
  }

  private static addRowVeicolo() {
    const inputsComponent = {} as AutocompleteControl;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'veicoloId';
    inputsComponent.controlType = 'autocomplete-vehicle' as any;
    inputsComponent.label =
      'Veicolo (Ricerca per numero pratica, targa, telaio o descrizione modello) minimo 4 caratteri';
    inputsComponent.class = 'w-full';
    inputsComponent.options = [];
    inputsComponent.customAction = 'onVehicleSelected';

    this.rows.push(inputsComponent);
  }

  private static addRowMarca() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'marca';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Marca';
    inputsComponent.class = 'w-4/12';
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowModello() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'modello';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Modello';
    inputsComponent.class = 'w-8/12';
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowTarga() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'targa';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Targa';
    inputsComponent.class = 'w-4/12';
    //inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowTelaio() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'telaio';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Telaio';
    inputsComponent.class = 'w-8/12';
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowBpCliente() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'bpCliente';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'BP Cliente';
    inputsComponent.class = 'w-4/12';
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }

  private static addRowLuogoContratto() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'luogoContratto';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'Luogo Contratto';
    inputsComponent.class = 'w-4/12';

    // Imposta "Lozza" come valore di default solo per i nuovi form
    if (this.isNewForm) {
      inputsComponent.default = 'Lozza';
    }

    this.rows.push(inputsComponent);
  }

  private static addRowDataContratto() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'dataContratto';
    inputsComponent.controlType = ControlType.date;
    inputsComponent.label = 'Data Contratto';
    inputsComponent.class = 'w-4/12';

    // Imposta a now come valore di default solo per i nuovi form
    if (this.isNewForm) {
      inputsComponent.default = new Date();
    }

    this.rows.push(inputsComponent);
  }

  private static addRowPraticaId() {
    const inputsComponent = {} as ControlBase;
    inputsComponent.classToUse = this.classToCall;
    inputsComponent.key = 'praticaId';
    inputsComponent.controlType = ControlType.textInput;
    inputsComponent.label = 'PraticaId';
    inputsComponent.class = 'w-4/12';
    inputsComponent.disabled = true;

    this.rows.push(inputsComponent);
  }
}
